/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationV2Request extends models.AppSecopsApplication {
    getFixupPrototypeFunction() { return AppSecopsApplicationV2Request.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationV2Request>): AppSecopsApplicationV2Request {
        let obj = Object.assign(new AppSecopsApplicationV2Request(), model);
        AppSecopsApplicationV2Request.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationV2Request>): AppSecopsApplicationV2Request {
        if (!model) return null;
        return AppSecopsApplicationV2Request.newInstance(<AppSecopsApplicationV2Request> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationV2Request) {
        if (!obj) return;

        models.AppSecopsApplicationV2Request.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationV2Request): boolean {
        if (models.AppSecopsApplication.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsApplicationV2Request.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.selected) {
            for (let val of this.selected) {
                models.AppSecopsApplicationV2BCSSelectedItem.fixupPrototype(val);
            }
        }
    }

    /**
     * BCS questionnaire answers
     */
    selected: Array<models.AppSecopsApplicationV2BCSSelectedItem>;

}
